import styled, { keyframes } from 'styled-components';

import { progressLine } from '../../AiManagerRefact/Model/aiProgressLine';

// 말풍선 밖에서 현재 활동 한 줄만 읽어 준다. 움직임 줄이기 설정도 따른다. //
export default function AiProgressTrail(props) {
  const { items, language, initialText, color } = props;
  const sparklePath = 'M12 3C13.1 8.6 15.4 10.9 21 12C15.4 13.1 13.1 15.4 12 21C10.9 15.4 8.6 13.1 3 12C8.6 10.9 10.9 8.6 12 3Z';

  return (
    <ProgressWrapper
      role='status'
      aria-live='polite'
      aria-atomic='true'
      $color={color}
    >
      <SparkleImage
        viewBox='0 0 24 24'
        aria-hidden='true'
        focusable='false'
      >
        <SparkleFillImage d={sparklePath} />
        <path d={sparklePath} />
      </SparkleImage>
      <ProgressTextWrapper>{progressLine(items, language, initialText)}</ProgressTextWrapper>
    </ProgressWrapper>
  );
}

const sparkleFill = keyframes`
  0%, 15%, 100% { clip-path: circle(0% at 50% 50%); }
  45%, 60% { clip-path: circle(50% at 50% 50%); }
`;

const gradientSweep = keyframes`
  from { background-position: 0% 50%; }
  to { background-position: 100% 50%; }
`;

const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 12px 4px;
  min-width: 0;
  color: ${props => props.$color || props.theme.primary || 'currentColor'};
  font-size: 14px;
  line-height: 1.6;
  overflow-wrap: anywhere;
`;

const ProgressTextWrapper = styled.span`
  min-width: 0;
  font-family: NotoSansKR-Medium;

  @supports ((background-clip: text) or (-webkit-background-clip: text)) and (color: color-mix(in srgb, black, white)) {
    background-image: linear-gradient(
      100deg,
      currentColor 15%,
      color-mix(in srgb, currentColor 65%, ${props => props.theme.pointRed || 'currentColor'}) 40%,
      ${props => props.theme.webBrand200 || 'currentColor'} 60%,
      currentColor 85%
    );
    background-size: 240% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: ${gradientSweep} 3.2s ease-in-out infinite alternate;
  }

  @media (prefers-reduced-motion: reduce) {
    background: none;
    -webkit-text-fill-color: currentColor;
    animation: none;
  }

  @media (forced-colors: active) {
    background: none;
    color: CanvasText;
    -webkit-text-fill-color: currentColor;
    animation: none;
  }
`;

const SparkleImage = styled.svg`
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.7;
  stroke-linejoin: round;

  @media (forced-colors: active) {
    color: CanvasText;
  }
`;

const SparkleFillImage = styled.path`
  fill: currentColor;
  stroke: none;
  opacity: .85;
  clip-path: circle(0% at 50% 50%);
  animation: ${sparkleFill} 3.2s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    clip-path: none;
    opacity: .2;
    animation: none;
  }

  @media (forced-colors: active) {
    display: none;
    animation: none;
  }
`;
